export const DOCTORS_PI_PERSONAL_DETAILS_FORM = 'doctorsPi/personalDetailsForm/';

export const DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM + 'setValue';
export const DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID = DOCTORS_PI_PERSONAL_DETAILS_FORM + 'setValid';

export const FORM_VALID_DOCTORS_PI_PERSONAL_DETAILS_FORM = 'doctorsPi/personalDetailsForm/transition/formValid';
export const FORM_INVALID_DOCTORS_PI_PERSONAL_DETAILS_FORM = 'doctorsPi/personalDetailsForm/transition/formInValid';

export const REINITIALIZE = 'doctorsPi/personalDetailsForm/state/reinitialize';

export const transitionDoctorsPiPersonalDetails = {
    formValid: () => ({
        type: FORM_VALID_DOCTORS_PI_PERSONAL_DETAILS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_DOCTORS_PI_PERSONAL_DETAILS_FORM,
    }),
};

// API Calls actions
export const API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM = `${DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/initial`;
export const API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM = `${DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/pending`;
export const API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM = `${DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/success`;
export const API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM = `${DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE}/apiTransition/failure`;

export const apiTransitionPersonalDetailsForm = {
    initial: () => ({
        type: API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM,
    }),
};

export const FIRST_NAME_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'firstName';
export const FIRST_NAME_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'firstName';

export const SURNAME_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'surname';
export const SURNAME_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'surname';

export const DOB_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'dob';
export const DOB_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'dob';

export const EMAIL_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'email';
export const EMAIL_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'email';

export const MOBILE_NUMBER_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'mobileNumber';
export const MOBILE_NUMBER_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'mobileNumber';

export const ID_PASSPORT_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'idPassport';
export const ID_PASSPORT_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'idPassport';

export const KRA_PIN_NUMBER_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'kraPinNumber';
export const KRA_PIN_NUMBER_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'kraPinNumber';

export const CITY_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'city';
export const CITY_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'city';

export const STREET_ADDRESS_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'streetAddress';
export const STREET_ADDRESS_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'streetAddress';

export const BUILDING_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'building';
export const BUILDING_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'building';

export const PO_BOX_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'postalBox';
export const PO_BOX_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'postalBox';

export const POSTAL_CODE_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'postalCode';
export const POSTAL_CODE_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'postalCode';

export const PERSONAL_DETAIL_ID_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'pid';
export const PERSONAL_DETAIL_ID_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'pid';

export const COLLECT_PERSONAL_DETAILS_DATA = DOCTORS_PI_PERSONAL_DETAILS_FORM + 'collectPersonalDetails';
export const UPLOAD_DOCUMENTS_DATA = DOCTORS_PI_PERSONAL_DETAILS_FORM + 'uploadDocuments';

export const REFERRED_SET_VALUE = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VALUE + 'referred';
export const REFERRED_SET_VALID = DOCTORS_PI_PERSONAL_DETAILS_FORM_SET_VAVID + 'referred';

// Action Creators

export const setFirstNameValue = (value) => ({
    type: FIRST_NAME_SET_VALUE,
    value,
});

export const setFirstNameValid = (error) => ({
    type: FIRST_NAME_SET_VALID,
    error,
});

export const setSurnameValue = (value) => ({
    type: SURNAME_SET_VALUE,
    value,
});

export const setSurnameValid = (error) => ({
    type: SURNAME_SET_VALID,
    error,
});

export const setDobValue = (value) => ({
    type: DOB_SET_VALUE,
    value,
});

export const setDobValid = (error) => ({
    type: DOB_SET_VALID,
    error,
});

export const setEmailValue = (value) => ({
    type: EMAIL_SET_VALUE,
    value,
});

export const setEmailValid = (error) => ({
    type: EMAIL_SET_VALID,
    error,
});

export const setMobileNumberValue = (value) => ({
    type: MOBILE_NUMBER_SET_VALUE,
    value,
});

export const setMobileNumberValid = (error) => ({
    type: MOBILE_NUMBER_SET_VALID,
    error,
});

export const setIdPassportValue = (value) => ({
    type: ID_PASSPORT_SET_VALUE,
    value,
});

export const setIdPassportValid = (error) => ({
    type: ID_PASSPORT_SET_VALID,
    error,
});

export const setKraPinNumberValue = (value) => ({
    type: KRA_PIN_NUMBER_SET_VALUE,
    value,
});

export const setKraPinNumberValid = (error) => ({
    type: KRA_PIN_NUMBER_SET_VALID,
    error,
});

export const setCityValue = (value) => ({
    type: CITY_SET_VALUE,
    value,
});

export const setCityValid = (error) => ({
    type: CITY_SET_VALID,
    error,
});

export const setStreetAddressValue = (value) => ({
    type: STREET_ADDRESS_SET_VALUE,
    value,
});

export const setStreetAddressValid = (error) => ({
    type: STREET_ADDRESS_SET_VALID,
    error,
});

export const setBuildingValue = (value) => ({
    type: BUILDING_SET_VALUE,
    value,
});

export const setBuildingValid = (error) => ({
    type: BUILDING_SET_VALID,
    error,
});

export const setPostalBoxValue = (value) => ({
    type: PO_BOX_SET_VALUE,
    value,
});

export const setPostalBoxValid = (error) => ({
    type: PO_BOX_SET_VALID,
    error,
});

export const setPostalCodeValue = (value) => ({
    type: POSTAL_CODE_SET_VALUE,
    value,
});

export const setPostalCodeValid = (error) => ({
    type: POSTAL_CODE_SET_VALID,
    error,
});

export const setPersonalDetailIdValue = (value) => ({
    type: PERSONAL_DETAIL_ID_SET_VALUE,
    value,
});

export const setPersonalDetailIdValid = (error) => ({
    type: PERSONAL_DETAIL_ID_SET_VALID,
    error,
});

export const collectPersonalDetails = () => ({
    type: COLLECT_PERSONAL_DETAILS_DATA,
});

export const uploadDocuments = () => ({
    type: UPLOAD_DOCUMENTS_DATA,
});

export const setReferredValue = (value) => ({
    type: REFERRED_SET_VALUE,
    value,
});

export const setReferredValid = (error) => ({
    type: REFERRED_SET_VALID,
    error,
});
